import React, { useState, useEffect } from "react"
import { useAccessContext } from "@/contexts/AccessContext"
import GeoJsonLayer from "@/components/map/GeoJsonLayer"
import { coreGet } from "@/services/coreApi"
import { bindMapCard, useCloseMapCardWhenHidden } from "@/features/map/mapCardStore"

// Zone overlay served by core from the GIS files astar routes on (/geo/<path>).
// `rows(p)` maps feature properties to card rows [label, value]; falsy entries are dropped.
export default function CoreZoneLayer({
  flag,
  path,
  style,
  title,
  rows,
  toggleFlags,
  switchGisLayersActive,
}) {
  const { accessContext, setAccessContext } = useAccessContext()
  const [geojson, setGeojson] = useState(null)
  const enabled = switchGisLayersActive && toggleFlags.includes(flag)
  useCloseMapCardWhenHidden(`${path}-`, enabled)

  useEffect(() => {
    if (!enabled || geojson !== null) return

    let cancelled = false
    async function load() {
      try {
        const data = await coreGet(`/geo/${path}`, accessContext, setAccessContext, `.core /geo/${path} error=`)
        if (!cancelled) setGeojson(data)
      } catch (err) {
        console.error(err)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [accessContext, enabled, geojson, path, setAccessContext])

  if (!enabled || !geojson) return null

  return (
    <GeoJsonLayer
      data={geojson.features}
      style={style}
      onEachFeature={(feature, layer) => {
        const properties = feature?.properties || {}
        bindMapCard(layer, () => ({
          key: `${path}-${feature?.id ?? properties.id ?? properties.name}`,
          title,
          rows: rows(properties),
        }))
      }}
    />
  )
}
